import currentConfig from '../config.current.json';

const config = currentConfig;

if (!config) throw new Error();

export { config };
